import BoardContentContext from '@/context/apps/board/BoardContentContext';
import _isEmpty from 'lodash/isEmpty';
import { useContext } from 'react';

import getFileInfos from '@/utils/getFileInfos';

import CkEditorContent from '@/components/apps/ui/ckEditorContent/CkEditorContent';

import BoardDetailAttachmentFile from '../BoardDetailAttachmentFile';

export default function GeneralBoardDetail() {
  const context = useContext(BoardContentContext);
  if (!context) {
    throw new Error('Cannot find BoardContentContext');
  }

  const { data } = context;
  const { bc, file_info } = data;

  const fileFileInfos = getFileInfos({
    file_info: file_info,
    idx: bc.idx,
    fileCategory: 'bc_file',
    isFile: true,
  });

  return (
    <>
      {/* content 내용 */}
      <CkEditorContent content={bc.content as string} />

      {/* 첨부파일 */}
      {!_isEmpty(fileFileInfos) && (
        <BoardDetailAttachmentFile fileInfos={fileFileInfos} />
      )}
    </>
  );
}
